import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholders by Engagement Level',
      type: 'charts',
      alias: 'stakeholders-by-engagement-level',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Engagement Level',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Stakeholders',
                          color: '#2F5DA8',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'High-Touch / Individual',
                                  y: {
                                    '#': {
                                      '@': 'highTouchStakeholders',
                                    },
                                  },
                                  name: 'High-Touch / Individual',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      engagementNeeded:
                                                        'High-Touch / Individual',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                  description:
                                    'Individualized stakeholder engagement.',
                                },
                              },
                              {
                                '{}': {
                                  x: 'Targeted Group Engagement',
                                  y: {
                                    '#': {
                                      '@': 'targetedGroupStakeholders',
                                    },
                                  },
                                  name: 'Targeted Group Engagement',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      engagementNeeded:
                                                        'Targeted Group Engagement',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                  description:
                                    'Engagement tailored to a specific group.',
                                },
                              },
                              {
                                '{}': {
                                  x: 'Standard Group Engagement',
                                  y: {
                                    '#': {
                                      '@': 'standardGroupStakeholders',
                                    },
                                  },
                                  name: 'Standard Group Engagement',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      engagementNeeded:
                                                        'Standard Group Engagement',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                  description:
                                    'Standard group-level engagement.',
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Engagement Level',
                  yLabel: 'Stakeholders',
                  description: 'Stakeholder count by engagement level.',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    highTouchStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!engagement_needed',
          },
          'High-Touch / Individual',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    standardGroupStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!engagement_needed',
          },
          'Standard Group Engagement',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    targetedGroupStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!engagement_needed',
          },
          'Targeted Group Engagement',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
  },
}
